import keycloak from 'keycloak-js'

const clientId = process.env.REACT_APP_KEYCLOAK || 'workflow'
const url = process.env.REACT_APP_KEYCLOAK_URL || ''
const realm = process.env.REACT_APP_KEYCLOAK_REALM || 'master'

const keycloakConfig = keycloak({
  realm,
  url,
  clientId
})

const onKeycloakEvent = (event, error) => {
  console.log('onKeycloakEvent', event, error)
}

const onKeycloakTokens = (tokens) => {
  console.log('onKeycloakTokens', tokens)
  return true
}
const onAuthLogout = () => {
  // return null
  window.location = `${url}realms/${realm}/protocol/openid-connect/logout?client_id=${clientId}&redirect_uri=${encodeURIComponent(
    window.location.href
  )}`
}

const keycloakProviderInitConfig = {
  onLoad: 'login-required',
  responseMode: 'query',
  responseType: 'code',
  enableLogging: true
}

export {
  keycloakConfig,
  onKeycloakEvent,
  onKeycloakTokens,
  onAuthLogout,
  keycloakProviderInitConfig,
  clientId
}
